import { ISearchResult } from '../../state/types';
import { makeFetch } from './_shared/fetchMakers';
import { normalizeMonitoredCollection } from './_shared/normalizers';
import { makeSearchUrl } from './_shared/urlMakers';

export const fetchSearchResults = makeFetch<ISearchResult[]>(
    makeSearchUrl,
    normalizeMonitoredCollection
);
